export function isAsyncOperator(operator) {
    return 'generateEncryptedParametersAsync' in operator;
}
export function isSyncOperator(operator) {
    return !isAsyncOperator(operator);
}
